import React, { Component } from 'react';
import styles from './styles.scss';
import classNames from 'classnames';
import { shape, string, number, bool } from 'prop-types';

export default class DaypartTableSummary extends Component {
  static propTypes = {
    isShowNewAdUsers: bool,
    summaryData: shape({
      title: string,
      totalAdVisits: number,
      totalAds: number,
      totalVisitsPerAd: number,
      totalVisits: number,
      campaignAvgAdCost: number
    })
  }
  
  render() {
    const { summaryData, isShowNewAdUsers } = this.props;
    const {
      title,
      totalAdVisits,
      totalAds,
      totalVisitsPerAd,
      totalVisits,
      totalNewAdUsers,
      totalNewAdUsersPerAds,
      campaignAvgAdCost
    } = summaryData;
    const formattedTotalAdVisits = Math.round(totalAdVisits);
    return (
      <div className={classNames(styles.tableRow, styles.summaryRow)}>
        <div data-test="summaryTitle" className={classNames(styles.tableCell, styles.summaryCellTitle)}>{title}</div>
        <div className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalVisits.toFixed(1)).toLocaleString()}</div>
        {
          isShowNewAdUsers ?
          <div className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalNewAdUsers).toLocaleString()}</div> :
          <div data-test="summaryAdVisits" className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(formattedTotalAdVisits).toLocaleString()}</div>
        }
        <div data-test="summaryAds" className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalAds.toFixed(1)).toLocaleString()}</div>
        {
          isShowNewAdUsers ?
          <div className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalNewAdUsersPerAds.toFixed(2)).toLocaleString()}</div> :
          <div data-test="summaryVisitsAds" className={classNames(styles.tableCell, styles.summaryCell)}>{parseFloat(totalVisitsPerAd.toFixed(2)).toLocaleString()}</div>
        }
        {campaignAvgAdCost != null && <div data-test="summaryAdCost" className={classNames(styles.tableCell, styles.summaryCell)}>{`$${parseFloat(campaignAvgAdCost).toFixed(2).toLocaleString()}`}</div>}
      </div>
    )
  }
};
